// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
require('./_set-collection-from')('WeakMap');



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/modules/es7.weak-map.from.js
// module id = 1388
// module chunks = 168707334958949